export default __webpack_public_path__ + "static/media/build.3fa6fc9a.svg";